
import styled from 'styled-components';
import { ensurePxUnit } from '../utils/mobileUtils';

export const SectionWrapper = styled.div`
  opacity: ${({ isDragging }) => (isDragging ? 0.5 : 1)};
  
  /* Apply dynamic styles from section.properties */
  background-color: ${({ styleProps }) => styleProps.backgroundColor || '#f9f9f9'};
  border-style: ${({ styleProps }) => styleProps.borderStyle || 'solid'};
  border-radius: ${({ styleProps }) => ensurePxUnit(styleProps.cornerRadius || '8')};

  /* Selection border overrides other border colors */
  border-width: ${({ isSelected, styleProps }) => (isSelected ? '2px' : ensurePxUnit(styleProps.borderSize || '1'))};
  border-color: ${({ isSelected, styleProps }) => (isSelected ? '#F89B3C' : styleProps.borderColor || '#e0e0e0')};

  overflow: hidden; 
`;

export const SectionHeader = styled.div`
  padding: 8px 5px;
  border-bottom: 1px solid #e0e0e0;
  cursor: move;
  min-height: ${({ styleProps }) => ensurePxUnit(styleProps.titleHeight, '25px')};
  display: flex;
  align-items: center;

  /* Apply dynamic styles from section.properties */
  background-color: ${({ styleProps }) => styleProps.titleBackgroundColor};
  color: ${({ styleProps }) => styleProps.titleColor};
  font-family: ${({ styleProps }) => styleProps.titleFontFamily};
  font-size: ${({ styleProps }) => ensurePxUnit(styleProps.titleFontSize)};
  font-weight: ${({ styleProps }) => styleProps.titleTextWeight};
  font-style: ${({ styleProps }) => styleProps.titleTextStyle};
  justify-content: ${({ styleProps }) => 
    styleProps?.titleAlign === 'center' ? 'center' :
    styleProps?.titleAlign === 'right' ? 'flex-end' : 
    'flex-start'
  };
`;

export const SectionHeaderInput = styled.input`
  width: 100%;
  padding: 4px 8px;
  border: 1px solid #F89B3C;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  &:focus {
    outline: none;
  }
`;

export const DropArea = styled.div`
  padding: 5px;
  min-height: 50px;
  background-color: ${({ isOver, styleProps }) => (isOver ? '#FEF2E6' : styleProps.backgroundColor || '#fff')};
  color: #aaa;
  outline: ${({ isOver }) => (isOver ? '1px dashed #F89B3C' : 'none')};

  display: flex;
  flex-direction: column;
`;
